import React from 'react';
import { useNavigate } from 'react-router-dom';
import './DescriptionPage.css';

function TrainingIntroPage() {
  const navigate = useNavigate();

  return (
    <div className="page-container description-page">
      <h1>Тренировка перед основным экспериментом</h1>
      <p>Перед началом основной части вы увидите тренировочные видеоролики, которые помогут привыкнуть к процедуре.</p>
      <p>Перед каждым видео на экране появится фиксационная точка. Сосредоточьте на ней взгляд, пока ролик не начнётся.</p>
      <p>Задача может показаться сложной, так как эмоции могут быть неоднозначными. Тем не менее после каждого ролика ответ обязателен. Даже если вы сомневаетесь, выберите наиболее подходящий вариант.</p>
	  <p>После просмотра коснитесь на круговом колесе эмоций того сектора, который, по вашему мнению, соответствует увиденной эмоции. Без фиксации ответа переход к следующему ролику невозможен.</p>
      <div className="navigation-buttons">
         <button onClick={() => navigate('/training-task')}>Далее</button>
      </div>
    </div>
  );
}

export default TrainingIntroPage;